<nb-card *ngIf="!showCategoryDetail">
  <nb-card-header>
    Category
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="categorySettings" [source]="categorySource" (delete)="onDeleteCategory($event)" (edit)="onEditCategory($event)" (create)="onCreateCategory()">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="showCategoryDetail">
  <nb-card-header>
    Category detail
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="eventCategoryForm" (ngSubmit)="onSubmitCategory()">
      <div class="form-group">
        <label for="name" class="label">Category</label>
        <input type="text" nbInput fullWidth id="name" placeholder="Name" formControlName="name" [status]="c.name.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="sortOrder" class="label">Sort order</label>
        <input type="text" nbInput fullWidth id="sortOrder" placeholder="1" formControlName="sortOrder" [status]="c.sortOrder.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <button class="margin-right" type="submit" nbButton status="success">Save</button>
        <button class="margin-right" type="reset" (click)="onCancelCategory()" nbButton status="danger" >Cancel</button>
      </div>
    </form>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="!showDetail">
  <nb-card-header>
    Pricelist
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source" (delete)="onDelete($event)" (edit)="onEdit($event)" (create)="onCreate()">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="showDetail">
  <nb-card-header>
    Price detail
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="eventPricelistForm" (ngSubmit)="onSubmit()">
      <div class="form-group" *ngIf="imgFile">
          <img [src]="imgFile" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group" *ngIf="!imgFile">
        <img id="logo" [src]="photoURL" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group">
        <label class="upload" for="file" type="button">UPLOAD NEW IMAGE</label>
        <input type="file" nbInput class="form-control" id="file" formControlName="file" (change)="onImageChange($event)">
      </div>
      <div class="form-group">
        <label for="category" class="label">Category</label><br/>
        <nb-select placeholder="Select category" [(selected)]="category_id" formControlName="category_id" fullWidth [status]="e.category_id.errors ? 'danger' : ''">
          <nb-option *ngFor="let category of category_data" [value]="category.key">{{category.name}}</nb-option>
        </nb-select>
      </div>
      <div class="form-group">
        <label for="description" class="label">Description</label>
        <input type="text" nbInput fullWidth id="description" placeholder="Description" formControlName="description" [status]="e.description.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="price" class="label">Price</label>
        <input type="number" nbInput fullWidth id="price" placeholder="0" formControlName="price" [status]="e.price.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="sortOrder" class="label">Sort order</label>
        <input type="number" nbInput fullWidth id="sortOrder" placeholder="1" formControlName="sortOrder" [status]="e.sortOrder.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <button class="margin-right" type="submit" nbButton status="success">Save</button>
        <button class="margin-right" type="reset" (click)="onCancel()" nbButton status="danger" >Cancel</button>
      </div>
    </form>
  </nb-card-body>
</nb-card>
